import React from "react";
import UserDetailsHeader from "../../UserDetailsHeader";
import { Typography } from "@mui/material";
import romFlipImg from "../../../../assets/images/romflip.png";
import { ROM_RIGHT_FLEXION } from "../../../../routes/routerPath";
import { useNavigate } from "react-router-dom";
import { searchParams } from "../../../../utlis/helpers";
import { pageLocale } from "../../../../utlis/locale";

const ROMFlipScreen = () => {
  const navigate = useNavigate();
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const { flip_desc, got_it } = pageLocale("rom");
  return (
    <UserDetailsHeader>
      <div className="rom-details-screen">
        <Typography className="title">{getInfo?.moduleName}</Typography>
        <div className="rom-info-block">
          <div className="rom-details-content">
            <img src={romFlipImg} alt="rom-leftFlexion" className="test-img" />
            <Typography className="desc">{flip_desc}</Typography>
            {/* <div className="item-wrapper" onClick={() => viewReportHandler()}>
              <div className="item-name">
                <img src={viewReportIcon} alt="info" className="img" />
                <Typography>View Report</Typography>
              </div>
              <div className="arrow">
                <img src={forwardArrow} alt="forwardArrow" />
              </div>
            </div> */}
            <div className="proceed-btn-wrap">
              <button
                className="btn"
                onClick={() => navigate(ROM_RIGHT_FLEXION + `${searchParams}`)}
              >
                {got_it}
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserDetailsHeader>
  );
};

export default ROMFlipScreen;
